import moment from "moment";
import { useEffect, useState } from "react";
import useHttpHook from "../../../../Hooks/HttpHook";
import { AddToCart, RemoveFromCart } from "../../../../utils/ApiConstant";
import { dateFormatter } from "../../../../utils/Helper";
import { EventLanguage } from "../../../../utils/Languages";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { toast } from "react-toastify";
import ModalWrapper from "../../../Common/Portals/ModalWrapper";
import { showErrorToast } from "../../../../utils/notify";

const getSaleState = (ticket) => {
  const now = new Date();
  const salesStart = new Date(ticket.salesStart);
  const salesEnd = new Date(ticket.salesEnd);

  if (now > salesEnd) {
    return { onSale: false, status: "Sale has been ended", unavailable: true };
  }
  if (now < salesStart) {
    return {
      onSale: false,
      status: `Sale will start on ${dateFormatter(ticket.salesStart)} ${moment(
        ticket.salesStart
      ).format("hh:mm a")}`,
      unavailable: true,
    };
  }
  return { onSale: true, status: "On sale", unavailable: false };
};

const TicketTypeForm = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [selectedContent, setSelectedContent] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [count, setCounter] = useState(0);

  useEffect(() => {
    setCounter(props.quantity);
  }, [props.quantity]);

  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  const saleState = getSaleState(props.ticket);

  const cartAction = async (action) => {
    const data = {
      eventId: props.eventId,
      ticketId: props.ticket._id,
      referralId,
    };
    const cartData = await sendRequest(action, { method: "post", data });
    if (cartData.status === 1) {
      props.getCartData();
    }
  };

  useEffect(() => {
    if (error && toast.isActive(error) === false) {
      showErrorToast(error);
      if (error === "You are unAuthrised") {
        window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
      }
    }
  }, [error]);

  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <article
        className={`event-ticket-card${count > 0 ? " is-selected" : ""}`}
      >
        <div className="event-ticket-main">
          <div className="event-ticket-copy">
            <div className="event-ticket-head">
              <h3 className="event-ticket-name">{props.ticket.name}</h3>
              <button
                type="button"
                className="event-ticket-info"
                aria-label={`More information about ${props.ticket.name}`}
                onClick={() => {
                  setSelectedContent(props.ticket);
                  setShowModal(true);
                }}
              >
                <i className="bi bi-info-circle" aria-hidden="true"></i>
              </button>
            </div>
            <div className="event-ticket-price">USD {props.ticket.price}</div>
            <div
              className={`event-ticket-status${
                saleState.unavailable ? " is-unavailable" : ""
              }`}
            >
              {saleState.status}
            </div>
            {props.ticket.description && (
              <p className="event-ticket-desc">{props.ticket.description}</p>
            )}
          </div>

          {saleState.onSale ? (
            <div className="event-ticket-qty">
              {props.isShowRemainingTicket && (
                <span className="event-ticket-qty-label">
                  Remaining: {props.ticket.quantity}
                </span>
              )}
              <span className="event-ticket-qty-label">
                {EventLanguage.UserEvents.ticket.Qty}
              </span>
              <div className="event-qty-stepper">
                <button
                  type="button"
                  className="event-qty-btn"
                  aria-label="Decrease quantity"
                  onClick={() => cartAction(RemoveFromCart)}
                  disabled={count === 0 || loading}
                >
                  -
                </button>
                <span className="event-qty-value">{count}</span>
                <button
                  type="button"
                  className="event-qty-btn"
                  aria-label="Increase quantity"
                  onClick={() => cartAction(AddToCart)}
                  disabled={
                    count === props.ticket.maxTicketPerOrder ||
                    count === props.ticket.quantity ||
                    loading
                  }
                >
                  +
                </button>
              </div>
              <div className="event-ticket-limits">
                Min: {props.ticket.minTicketPerOrder} · Max:{" "}
                {props.ticket.maxTicketPerOrder}
              </div>
            </div>
          ) : null}
        </div>
      </article>

      {showModal && (
        <ModalWrapper
          title="Ticket Information"
          dialogClassName="event-ticket-info-dialog"
          contentClassName="event-ticket-info-modal"
          headerClassName="event-ticket-info-header"
          bodyClassName="event-ticket-info-body"
          footerClassName="event-ticket-info-footer"
          closeClass="event-ticket-info-btn-close"
          submitClass="event-ticket-info-btn-ok"
          clickHandler={() => setShowModal(false)}
          CloseModalHandler={() => setShowModal(false)}
        >
          <div className="event-ticket-info-item">
            <span className="event-ticket-info-label">Name:</span>
            <span className="event-ticket-info-value">
              {selectedContent?.name}
            </span>
          </div>
          <div className="event-ticket-info-item">
            <span className="event-ticket-info-label">Sale:</span>
            <span className="event-ticket-info-value">
              {dateFormatter(new Date(selectedContent.salesStart))} -{" "}
              {dateFormatter(new Date(selectedContent.salesEnd))}
            </span>
          </div>
          <div className="event-ticket-info-validity">
            <span className="event-ticket-info-label">Validity:</span>
            <div className="event-ticket-info-table-wrap">
              <table className="event-ticket-info-table">
                <thead>
                  <tr>
                    <th scope="col">Start</th>
                    <th scope="col">End</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedContent?.ticketStart?.map((start, startIndex) =>
                    selectedContent?.ticketEnd?.map((end, endIndex) =>
                      startIndex === endIndex ? (
                        <tr key={`${startIndex}-${endIndex}`}>
                          <td>{moment(start).format("MMMM Do YYYY, h:mm a")}</td>
                          <td>{moment(end).format("MMMM Do YYYY, h:mm a")}</td>
                        </tr>
                      ) : null
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </ModalWrapper>
      )}
    </MainComponentWrapper>
  );
};

export default TicketTypeForm;
